import { useMutation } from '@debbie/common/dist/util/hooks.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import Badge from './Badge.js';
import Button from './Button.js';
import { Plus, X } from './Icons/index.js';
import Modal from './Modal.js';
import SearchInput from './SearchInput.js';
import Table from './Table.js';
const TagsEditor = (props) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        props.tags.map((tag, index) => (React.createElement(Badge, { style: {
                fontSize: '0.6em',
                marginLeft: index !== 0 ? '10px' : undefined,
                cursor: 'pointer',
            }, onClick: () => {
                if (!props.disabled) {
                    setOpen(!open);
                }
            }, theme: THEME.COLOR_ACCENT, title: tag.from || tag.to
                ? `(${tag.from
                    ? moment(tag.from).format(THEME.DATE_FORMAT_LONG)
                    : '∞'} - ${tag.to ? moment(tag.to).format(THEME.DATE_FORMAT_LONG) : '∞'})`
                : '' },
            (props.translations && props.translations[tag.tag]) || tag.tag,
            ' ',
            tag.from || tag.to
                ? `(${tag.from
                    ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                    : '∞'} - ${tag.to ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT) : '∞'})`
                : ''))),
        props.tags.length === 0 && (React.createElement(Badge, { style: { cursor: 'pointer', fontSize: '0.6em' }, theme: THEME.NEUTRAL, onClick: () => {
                if (!props.disabled) {
                    setOpen(!open);
                }
            } },
            React.createElement(Plus, { style: { margin: '0.2em 0 -0.2em 0' } }),
            " Tags")),
        open && React.createElement(TagsModal, { ...props, setOpen: setOpen })));
};
export default TagsEditor;
const TagsModal = (props) => {
    const lang = useSelector((state) => state.lang);
    const [tags, setTags] = useState(props.tags);
    const [availableTags, setAvailableTags] = useState(props.availableTags || []);
    const saveMutation = useMutation(() => props.onChange(tags), {
        onSuccess: () => {
            props.setOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.tags);
        },
    });
    const loadTags = async () => {
        if (props.loadUsedTags) {
            setAvailableTags(availableTags.concat(await props.loadUsedTags()));
        }
    };
    useEffect(() => {
        loadTags();
    }, []);
    return (React.createElement(Modal, { header: "Tags", onToggle: () => props.setOpen(false), maxWidth: "400px" },
        React.createElement(Table, { zebra: true }, tags.map((tag, index) => (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(Badge, { style: {
                        fontSize: '0.6em',
                    }, theme: THEME.COLOR_ACCENT, title: tag.from || tag.to
                        ? `(${tag.from
                            ? moment(tag.from).format(THEME.DATE_FORMAT_LONG)
                            : '∞'} - ${tag.to
                            ? moment(tag.to).format(THEME.DATE_FORMAT_LONG)
                            : '∞'})`
                        : '' },
                    (props.translations && props.translations[tag.tag]) || tag.tag,
                    ' ',
                    tag.from || tag.to
                        ? `(${tag.from
                            ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                            : '∞'} - ${tag.to
                            ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT)
                            : '∞'})`
                        : '')),
            React.createElement("td", null,
                React.createElement(X, { style: { cursor: 'pointer', float: 'right' }, onClick: () => setTags(tags.filter((_, i) => i !== index)) })))))),
        React.createElement("br", null),
        ((props.single && tags.length === 0) || !props.single) && (React.createElement(SearchInput, { placeholder: "+ tag", forceOpen: true, autofocus: true, searchAll: (q) => {
                let res = [];
                if (availableTags.length) {
                    res = res.concat(availableTags
                        .filter((t) => {
                        if (!q) {
                            return true;
                        }
                        return ((props.translations && props.translations[t]) || t)
                            .toLowerCase()
                            .includes(q.toLowerCase());
                    })
                        .map((t) => ({
                        heading: (props.translations && props.translations[t]) || t,
                        returnData: t,
                        key: t,
                    })));
                }
                if (q && !res.find((r) => r.returnData === q)) {
                    res = res.concat({
                        heading: `+ "${q}"`,
                        returnData: q,
                        key: q,
                    });
                }
                return res;
            }, onSelect: (t) => {
                setTags(tags.concat({
                    tag: t,
                    from: null,
                    to: null,
                }));
            } })),
        React.createElement(Button, { block: true, loading: saveMutation.isLoading, onClick: () => saveMutation.mutate() },
            lang.inputs.save,
            ' ')));
};
//# sourceMappingURL=TagsEditor.js.map